export default "__VITE_ASSET__jy8BgO8U__"